export default __webpack_public_path__ + "static/Messaging Platform – Photography – 1920x530-26cea0874c09ee7fd2ebfe82fd58415b.jpg";